// components/agent/employees/AgentEmployeesComponent.jsx
"use client";
import { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
// import { IoIosList } from "react-icons/io";
// import { CiGrid41 } from "react-icons/ci";
// import { BsToggleOn, BsToggleOff } from "react-icons/bs";
import AgentGridEmployees from "./AgentGridEmployees";
import AgentTableEmployees from "./AgentTableEmployees";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAgents,
  clearAgents,
  createAgent,
  resetSuccess,
} from "../../../redux/features/agentSlice";
import { fetchUserInfo } from "../../../redux/features/userSlice";
import CreateEmployeeForm from "../../admin/employees/CreateEmployee.jsx";

export default function AgentEmployeesComponent() {
  const dispatch = useDispatch();
  const [isGridView, setIsGridView] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    agents = [],
    isLoading,
    isCreating,
    error,
    success,
  } = useSelector((state) => state.agents);
  const { userInfo } = useSelector((state) => state.user);
  const isSubAdmin =
    userInfo?.role === "sub-admin" ||
    userInfo?.role === "subadmin" ||
    userInfo?.role === "admin";

  // Fetch agents on mount and clear on unmount
  useEffect(() => {
    dispatch(fetchAgents());
    dispatch(fetchUserInfo());
    
    return () => {
      dispatch(clearAgents());
    };
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      setIsModalOpen(false);
      dispatch(resetSuccess());
    }
  }, [success, dispatch]);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const handleSubmit = async (formData) => {
    dispatch(createAgent(formData));
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="w-8 h-8 border-4 border-blue-900 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="p-4 md:p-6">
      <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-col md:flex-row md:items-center gap-4">
          <h1 className="text-xl md:text-2xl font-medium text-nowrap">
            All Employees
          </h1>
          {isSubAdmin && (
            <button
              onClick={openModal}
              className="w-auto py-2 px-8 bg-[#036494] text-white rounded-full text-sm hover:bg-[#025177] transition-colors"
            >
              Add Employee
            </button>
          )}
        </div>

        <div className="flex items-center justify-end gap-4">
          {/* View toggle logic commented out as per original component, but can be enabled if needed */}
          {/* <IoIosList
            className={`text-2xl md:text-3xl cursor-pointer transition-colors ${
              !isGridView
                ? "text-blue-600"
                : "text-gray-500 hover:text-gray-700"
            }`}
            onClick={() => setIsGridView(false)}
          /> */}

          {/* <button
            onClick={() => setIsGridView(!isGridView)}
            className="text-2xl md:text-3xl"
          >
            {isGridView ? (
              <BsToggleOn className="text-blue-600" />
            ) : (
              <BsToggleOff className="text-slate-600" />
            )}
          </button> */}

          {/* <CiGrid41
            className={`text-2xl md:text-3xl cursor-pointer transition-colors ${
              isGridView ? "text-blue-600" : "text-gray-500 hover:text-gray-700"
            }`}
            onClick={() => setIsGridView(true)}
          /> */}
        </div>
      </div>

      {agents && (
        <>
          {isGridView ? (
            <AgentGridEmployees agents={agents} />
          ) : (
            <AgentTableEmployees agents={agents} />
          )}
          {/* IF THERES NO AGENTS, SHOW A MESSAGE */}
          {agents.length === 0 && (
            <div className="flex items-center justify-center min-h-[400px]">
              <p className="text-gray-500">No employees found.</p>
            </div>
          )}
        </>
      )}

      <AnimatePresence>
        <CreateEmployeeForm
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          onSubmit={handleSubmit}
          error={error}
          isCreating={isCreating}
        />
      </AnimatePresence>
    </div>
  );
}